export const SMALLER_HEIGHT = 170;
export const BIGGER_HEIGHT = 300;
export const SMALLER_TERMS_HEIGHT = 80;
export const BIGGER_TERMS_HEIGHT = 40;

export const calcCarouselHeight = ({ height, isSmall, isTermsConditionsEnabled }) => {
	return `calc(${height}px ${isTermsConditionsEnabled && (isSmall ? SMALLER_TERMS_HEIGHT : BIGGER_TERMS_HEIGHT)}px)`;
};
